<template>
  <div>
    <q-form ref="editForm">
      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="해임정보" class="cardClassDetailForm revisionLayout" topClass="topcolor-orange" v-if="popupParam.seniorStatusId" :collapsed="true">
            <template slot="card-detail">
             <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                <div class="row">
                  <div class="col-1">
                    <c-text
                      :required="editable && isRevision"
                      :editable="editable && isRevision"
                      label="Rev"
                      name="revisionNum"
                      v-model="data.revisionNum">
                    </c-text>
                  </div>
                  <!-- <div class="col-4">
                    <c-text
                      :editable="false"
                      label="개정일시"
                      name="regDtStr"
                      v-model="data.regDtStr">
                    </c-text>
                  </div> -->
                  <div class="col-3">
                    <c-datepicker
                      :editable="editable && isRevision"
                      :required="editable && isRevision"
                      label="해임일"
                      name="dismissalDate"
                      v-model="data.dismissalDate"
                    />
                  </div>
                  <div class="col-8">
                    <c-text
                      :required="editable && isRevision"
                      :editable="editable && isRevision"
                      label="해임사유"
                      name="revisionContent"
                      v-model="data.revisionContent">
                    </c-text>
                  </div>
                </div>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
          <c-card title="선임현황 기본정보" class="cardClassDetailForm">
            <template slot="card-select">
              <c-select
                :editable="!isRevision"
                v-if="popupParam.seniorStatusId"
                :comboItems="gridrev.data"
                type="custom"
                typetxt="선임이력"
                itemText="revisionNum"
                itemValue="seniorStatusId"
                name="selectedseniorStatusId"
                label=""
                v-model="selectedseniorStatusId"
                @input="rowClickRev"
              ></c-select>
            </template>
            <template slot="card-button">
              <q-btn-group outline >
                <c-btn
                  v-show="editable && popupParam.seniorStatusId && !isRevision"
                  label="해임 이후 선임"
                  icon="restart_alt"
                  @btnClicked="setRevision" />
                <c-btn
                  v-show="editable && popupParam.seniorStatusId && isRevision"
                  label="취소"
                  icon="restart_alt"
                  @btnClicked="cancelRevision" />
                <c-btn
                  v-if="editable && popupParam.seniorStatusId"
                  label="삭제"
                  icon="remove"
                  @btnClicked="deleteData"/>
                <c-btn
                  v-if="editable"
                  :url="saveUrl"
                  :isSubmit="isSave"
                  :param="data"
                  :mappingType="mappingType"
                  label="저장"
                  icon="save"
                  @beforeAction="saveData"
                  @btnCallback="saveCallback" />
              </q-btn-group>
            </template>
            <template slot="card-detail">
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-text
                  required
                  :editable="editable"
                  :disabled="true"
                  :afterIcon="[
                    { name: 'search', click: true, callbackName: 'searchSenior', color: 'teal' },
                    { name: 'close', click: true, callbackName: 'removeSenior', color: 'red' }
                  ]"
                  label="선해임명"
                  name="seniorName"
                  v-model="data.seniorName"
                  @searchSenior="openSenior"
                  @removeSenior="removeSenior">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-plant
                  required
                  :editable="editable"
                  type="edit"
                  name="plantCd"
                  v-model="data.plantCd">
                </c-plant>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-field 
                  required
                  type="dept_user" 
                  :editable="editable"
                  :data="data"
                  deptValue="seniorDeptCd"
                  label="부서 & 선임자" 
                  name="seniorUserId" 
                  v-model="data.seniorUserId" />
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-datepicker
                  required
                  label="선임일"
                  :start="data.seniorDate"
                  :editable="editable"
                  name="seniorDate"
                  v-model="data.seniorDate"
                />
              </div>
              <!-- <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 col-xl-5">
                    <c-radio
                      :editable="editable"
                      :comboItems="dismissalFlagItems"
                      label="해임여부"
                      name="dismissalFlag"
                      v-model="data.dismissalFlag"
                      @datachange="datachange">
                    </c-radio>
                  </div>
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7 col-xl-7">
                    <c-datepicker
                      :editable="editable"
                      :disabled="data.dismissalFlag !== 'Y'"
                      label="해임일"
                      :start="data.seniorDate"
                      name="dismissalDate"
                      v-model="data.dismissalDate"
                    />
                  </div>
                </div>
              </div> -->
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-text
                  :editable="editable"
                  label="관련자격증"
                  name="relatedCertificate"
                  v-model="data.relatedCertificate">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-text
                  :editable="editable"
                  label="자격증번호"
                  name="certificateNo"
                  v-model="data.certificateNo">
                </c-text>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-3 col-xl-3">
                <c-datepicker
                  :editable="editable"
                  label="자격취득일"
                  name="certificateAcquiDate"
                  v-model="data.certificateAcquiDate">
                </c-datepicker>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-12 col-lg-6 col-xl-6">
                <c-multi-select
                  :editable="editable"
                  codeGroupCd="REGULATION_BILL_CD"
                  itemText="codeName"
                  itemValue="code"
                  label="관련 법규"
                  :disabled="true"
                  name="relatedLaws"
                  maxValues="3"
                  v-model="data.relatedLaws">
                </c-multi-select>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!-- 자격요건 -->
                <c-textarea
                  name="qualifiyRequire"
                  label="자격요건"
                  :disabled="true"
                  :rows="2"
                  v-model="data.qualifiyRequire"
                ></c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!-- 관련근거 -->
                <c-textarea
                  name="relatedReason"
                  label="관련근거"
                  :rows="2"
                  v-model="data.relatedReason"
                ></c-textarea>
              </div>
              <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 col-xl-6">
                <!-- 수행역할 -->
                <c-textarea
                  name="seniorReason"
                  label="수행역할"
                  :rows="2"
                  v-model="data.seniorReason"
                ></c-textarea>
              </div>
            </template>
          </c-card>
        </div>
        <div class="col-6">
          <c-table
            ref="table"
            title="관련 교육과정"
            tableId="equipmentInsp"
            :columns="grid.columns"
            :data="data.eduStatusList"
            gridHeight="340px"
            :filtering="false"
            :isExcelDown="false"
            :checkClickFlag="false"
            :usePaging="false"
            rowKey="seniorId"
          >
          </c-table>
        </div>
        <div class="col-6">
          <c-card title="관련 선해임자료 및 자격증" class="cardClassDetailForm">
            <template slot="card-detail">
              <div class="col-sm-12 col-md-12 col-lg-12" style="height: 280px">
                <c-upload
                  :attachInfo="attachInfo"
                  :editable="editable"
                  label="관련 선해임자료 및 자격증">
                </c-upload>
              </div>
            </template>
          </c-card>
        </div>
      </div>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar'
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'senior-dismissal-status-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        seniorStatusId: '',
      }),
    },
  },
  data() {
    return {
      attachable: false,
      attachInfo: {
        isSubmit: '',
        taskClassCd: 'DISMISSAL_ATTACH',
        taskKey: '',
        beforeTaskKey: '',
        isRev: false,
      },
      grid: {
        columns: [
          {
            name: "educationCourseName",
            field: "educationCourseName",
            label: "교육과정",
            style: 'width:70%',
            align: 'left',
            sortable: true,
          },
          {
            name: "educationCycleName",
            field: "educationCycleName",
            label: "교육주기",
            // style: 'width:100px',
            align: 'center',
            sortable: true,
          },
          // {
          //   name: "evaluationDate",
          //   field: "evaluationDate",
          //   label: "최근 교육이수일",
          //   style: 'width:100px',
          //   align: 'center',
          //   sortable: true,
          // },
          // {
          //   name: "eduNextDate",
          //   field: "eduNextDate",
          //   label: "차기 교육이수일",
          //   style: 'width:100px',
          //   align: 'center',
          //   sortable: true,
          // },
        ],
        data: [],
      },
      selectedseniorStatusId: null,
      mappingType: 'POST',
      saveUrl: transactionConfig.mdm.senior.status.insert.url,
      insertUrl: '',
      updateUrl: '',
      deleteUrl: '',
      revlistUrl: '',
      revInsertUrl: '',
      editable: true,
      isSave: false,
      isdelete: false,
      isRevision: false,
      data: {
        seniorStatusId: '',
        relatedLaws: '',
        seniorName: '',
        qualifiyRequire: '',
        seniorUserId: '',
        seniorDate: '',
        seniorDeptCd: '',
        seniorDeptName: '',
        relatedCertificate: '',
        dismissalDate: '',
        certificateNo: '',
        certificateAcquiDate: '',
        relatedReason: '',
        seniorReason: '',
        revisionNum: '',
        groupId: '',
        dismissalFlag: 'N',
        sysRevision: 1,
        revisionContent: '제정',
        seniorId: '',
        regDtStr: '',
        regUserName: '',

        beforeKey: '',

        eduStatusList: [],
      },
      dismissalFlagItems: [
        { code: 'Y', codeName: 'YES' },
        { code: 'N', codeName: 'NO' },
      ],
      popupOptions: {
        target: null,
        title: '',
        visible: false,
        width: '90%',
        top: '10px',
        param: {},
        closeCallback: null,
      },
      gridrev: {
        columns: [
          {
            name: 'revisionNum',
            field: 'revisionNum',
            label: '개정번호',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
          {
            name: 'revisionContent',
            field: 'revisionContent',
            label: '개정사유',
            align: 'left',
            sortable: true,
          },
          {
            name: 'regDtStr',
            field: 'regDtStr',
            label: '개정일시',
            style: 'width: 150px',
            align: 'center',
            sortable: true,
          },
          {
            name: 'regUserName',
            field: 'regUserName',
            label: '개정자',
            align: 'center',
            style: 'width: 80px',
            sortable: true,
          },
        ],
        data: [],
      },
      realKey: '',
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.mdm.senior.status.get.url;
      this.insertUrl = transactionConfig.mdm.senior.status.insert.url;
      this.updateUrl = transactionConfig.mdm.senior.status.update.url;
      this.revInsertUrl = transactionConfig.mdm.senior.status.rev.insert.url;
      this.deleteUrl = transactionConfig.mdm.senior.status.delete.url;
      this.revlistUrl = selectConfig.mdm.senior.status.rev.url;
      this.getData();
    },
    getData() {
      this.isRevision = false;
      if (this.popupParam.seniorStatusId) {
        this.getDetail(this.popupParam.seniorStatusId, true);
        this.selectedseniorStatusId = this.popupParam.seniorStatusId;
      }
    },
    getDetail(_seniorStatusId, _check) {
      this.$http.url = this.$format(this.detailUrl, _seniorStatusId);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data = _result.data;
        this.$set(this.attachInfo, 'taskKey', _seniorStatusId)
        this.isRevision = false;
        if (_check) {
          this.getRevList(_result.data.groupId);
        }
        if(_result.data.seniorStatusId == this.popupParam.seniorStatusId) {
          this.editable = this.$route.meta.editable;
        } else {
          this.editable = false;
        }
      },);
    },
    saveData() {
      if (this.popupParam.seniorStatusId) {
        this.saveUrl = this.updateUrl;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = this.insertUrl;
        this.mappingType = 'POST';
      }
      let saveMsg = '저장하시겠습니까?';
      if (this.isRevision) {
        this.data.dismissalFlag = 'Y'
        saveMsg = '현재버전을 개정하여 저장하시겠습니까?';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: saveMsg,
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.data.regUserId = this.$store.getters.user.userId;
              this.data.chgUserId = this.$store.getters.user.userId;
              // 개정시
              if (this.isRevision) {
                this.saveUrl = this.revInsertUrl;
                this.mappingType = 'POST';
                this.data.sysRevision = parseInt(this.data.sysRevision) + 1;
                this.data.beforeKey = this.popupParam.seniorStatusId
              }
              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    deleteData() {
      window.getApp.$emit('CONFIRM', {
        title: '확인',
        message: '삭제하시겠습니까?',
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.seniorStatusId, this.data.groupId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            this.isdelete = !this.isdelete;
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.seniorStatusId = result.data
      this.$set(this.attachInfo, 'taskKey', this.popupParam.seniorStatusId)
      this.$set(this.attachInfo, 'isSubmit', uid())
      this.$set(this.attachInfo, 'beforeTaskKey', '')
      this.$set(this.attachInfo, 'isRev', false)
      this.getData();
    },
    setRevision() {
      this.$http.url = selectConfig.com.revision.getversion;
      this.$http.param = {revisionNum: this.data.revisionNum}
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.data.revisionNum = _result.data;
        this.data.revisionContent = '';
        this.data.regDtStr = '';
        this.data.regUserName = '';
        this.data.dismissalDate = '';
        this.data.seniorUserId = '';
        this.data.seniorDate = '';
        this.data.eduStatusList = []
        this.isRevision = true;
        this.$set(this.attachInfo, 'taskKey', '')
        this.$set(this.attachInfo, 'beforeTaskKey', this.popupParam.seniorStatusId)
        this.$set(this.attachInfo, 'isRev', true)
      });
    },
    cancelRevision() {
      this.isRevision = false;
      this.getData();
    },
    getRevList(_groupId) {
      this.$http.url = this.revlistUrl;
      this.$http.type = 'GET';
      this.$http.param = {groupId: _groupId};
      this.$http.request((_result) => {
        this.gridrev.data = _result.data;
      },);
    },
    rowClickRev(row) {
      if (row) {
        this.selectedseniorStatusId = row;
        if (row != this.data.seniorStatusId) {
          this.getDetail(this.selectedseniorStatusId, false);
        }
      }
    },
    openSenior() {
      this.popupOptions.title = '선해임명 검색'; // 선해임명 검색
      this.popupOptions.param = {
        type: 'single',
      };
      this.popupOptions.target = () => import(`${'./seniorDismissalPop.vue'}`);
      this.popupOptions.width = '70%';
      this.popupOptions.visible = true;
      this.popupOptions.closeCallback = this.closeSeniorPopup;
    },
    closeSeniorPopup(data) {
      this.popupOptions.target = null;
      this.popupOptions.visible = false;
      if (data && data.length > 0) {
        this.data.relatedLaws = data[0].relatedLaws;
        this.data.seniorName = data[0].seniorName;
        this.data.qualifiyRequire= data[0].qualifiyRequire;
        this.data.seniorClassCd = data[0].seniorClassCd;
        this.data.seniorFieldCd = data[0].seniorFieldCd;
        this.data.seniorId = data[0].seniorId;
      }
    },
    removeSenior() {
      this.data.relatedLaws = '';
      this.data.seniorName = '';
      this.data.qualifiyRequire = '';
      this.data.seniorClassCd = '';
      this.data.seniorFieldCd = '';
      this.data.seniorId = '';
    },
    datachange() {
      this.data.dismissalDate = ''
    }
  }
};
</script>
